<div id="list-text-gadget" class="px-5 py-3" >
  <h3 translate>{{title}}</h3>
  <h5>{{dataCount}} <span translate>Answers</span></h5>
  @if (data && data.length) {
    <div class="mt-3">
      @for (item of data; track item; let i = $index) {
        <ul class="py-1" [hidden]="i >= 3 && !open">
          <li>{{item.val}}</li>
        </ul>
      }
      <div class="show_more_less">
        @if (!open && data.length > 3) {
          <div type="button" class="" (click)="open=true" translate>Show More</div>
        }
        @if (open) {
          <div type="button" class=" " (click)="open=false" translate>Show Less</div>
        }
      </div>
    </div>
  }
</div>

